import DateInput from '@/common/components/base/input/dateInput/DateInput';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import Typography from '@/common/components/base/typography/Typography';
import { INSURANCE_NUMBER_RULE } from '@/common/utils/rules/insurance.rules';
import {
  validateNotFutureDate,
  validateNotPastDate,
} from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import useEditBodyInsurance from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/editBodyInsurance/hook/useEditBodyInsurance';
import { css } from 'styled-system/css';
import { Flex } from 'styled-system/jsx';

const PropertyForm = () => {
  const { insurances, isPending, setName } = useEditBodyInsurance();
  return (
    <Flex direction="column" gap="1" pt={24}>
      <Typography color={'purple-1'} mb={'1rem'} textStyle={'b1'}>
        اطلاعات بیمه شخص ثالث (اختیاری)
      </Typography>
      <ModalInput
        name="insurance_property_info.insurance"
        placeholder="انتخاب کنید"
        optionalLabel
        label="بیمه‌گر"
        title="بیمه‌گر"
        loading={isPending}
        searchOptions={{
          onChange: (e) => {
            setName(e);
          },
        }}
        options={insurances?.map((insurance) => ({
          label: insurance?.name as string,
          value: insurance?.id as number,
        }))}
      />
      <TextInput
        placeholder="شماره بیمه نامه را وارد کنید"
        label="شماره بیمه نامه"
        optionalLabel
        max={25}
        name="insurance_property_info.insurance_number"
        rules={{ ...INSURANCE_NUMBER_RULE }}
      />
      <Flex direction="row">
        <DateInput
          label="تاریخ شروع"
          buttonText="ثبت"
          optionalLabel
          modalLabel="تاریخ شروع"
          name="insurance_property_info.insurance_start_date"
          className={css({
            borderLeftRadius: '0px',
          })}
          rules={{ validate: validateNotFutureDate }}
          isDefaultValueEmpty={true}
        />
        <DateInput
          label="تاریخ انقضا"
          optionalLabel
          buttonText="ثبت"
          modalLabel="تاریخ انقضا"
          name="insurance_property_info.insurance_expiry_date"
          className={css({
            borderRightRadius: '0px',
          })}
          rules={{ validate: validateNotPastDate }}
          isDefaultValueEmpty={true}
        />
      </Flex>

      <DateInput
        label="تاریخ انقضا بیمه نامه سال قبل"
        buttonText="ثبت"
        optionalLabel
        modalLabel="تاریخ انقضا بیمه نامه سال قبل"
        name="insurance_property_info.insurance_expiry_date_last_year"
        rules={{ validate: validateNotFutureDate }}
        isDefaultValueEmpty={true}
      />
    </Flex>
  );
};

export default PropertyForm;
